import React from 'react'

import { Layout, Section } from '@/components/layout'
import { Text } from '@/components/common'
import PricingMain from '@/components/blocks/PricingMain'
import FaqSection from '@/components/blocks/FaqSection'
import SubscriptionOffers from '@/components/Pages/Pricing/SubscriptionOffers'
import useBreakpoint from '@/hooks/useBreakpoint'
import { MOBILE_BREAKPOINT } from '@/constants'
import PricingMainMobile from '@/components/blocks/PricingMainMobile'
import SubscriptionOffersMobile from '@/components/Pages/Pricing/SubscriptionOffersMobile'

const pageId = 'pricing'
const faqs = ['notReady', 'subscription', 'cost', 'moneyBack', 'receiptsCost', 'support', 'storage', 'payMonthly', 'insightsAndVip']
const getMessageId = id => `pages.${pageId}.${id}`

export default function PricingPage() {
  const isDesktop = useBreakpoint(MOBILE_BREAKPOINT)

  if (!isDesktop) {
    return (
      <Layout.Content>
        <Section bgBrandTertiary>
          <PricingMainMobile hasBottomContent testIdPrefix="pricing-page" />
          <SubscriptionOffersMobile />
        </Section>

        <FaqSection faqs={faqs} />
      </Layout.Content>
    )
  }

  return (
    <Layout.Content>
      <Section bgBrandTertiary>
        <div className="max-w-900">
          <Text.H1 center messageId={getMessageId('header.title')} normal size="xlarge" />
        </div>
        <PricingMain hasBottomContent testIdPrefix="pricing-page" />
      </Section>

      <SubscriptionOffers />
      <FaqSection faqs={faqs} />
    </Layout.Content>
  )
}

PricingPage.layoutProps = {
  pageId,
}
